/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState,
} from '@sg/api/base-api-lib';
import { InstrumentsManagerApiConfig } from '../api-config';

import { InstrumentsManagerApi } from '../models';

@Injectable()
export class InstrumentsManagerApiClient extends BaseApiClient<InstrumentsManagerApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.instrumentsManagerApiConfig);
  }

  instrumentsManagerControllerPostInstrumentsSearch(
    params?: {
      body?: InstrumentsManagerApi.InstrumentSearchParamsDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?:
        | 'InstrumentId'
        | 'CountryOfListing'
        | 'CountryOfIncorporation'
        | 'Type'
        | 'Currency'
        | 'Isin'
        | 'BenchmarkFee';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<InstrumentsManagerApi.InstrumentDtoInstrumentSortCriteriaDtoPagingResultDto>;
  instrumentsManagerControllerPostInstrumentsSearch(
    params?: {
      body?: InstrumentsManagerApi.InstrumentSearchParamsDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?:
        | 'InstrumentId'
        | 'CountryOfListing'
        | 'CountryOfIncorporation'
        | 'Type'
        | 'Currency'
        | 'Isin'
        | 'BenchmarkFee';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<InstrumentsManagerApi.InstrumentDtoInstrumentSortCriteriaDtoPagingResultDto>
  >;
  instrumentsManagerControllerPostInstrumentsSearch(
    params?: {
      body?: InstrumentsManagerApi.InstrumentSearchParamsDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?:
        | 'InstrumentId'
        | 'CountryOfListing'
        | 'CountryOfIncorporation'
        | 'Type'
        | 'Currency'
        | 'Isin'
        | 'BenchmarkFee';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<InstrumentsManagerApi.InstrumentDtoInstrumentSortCriteriaDtoPagingResultDto>;
  instrumentsManagerControllerPostInstrumentsSearch(
    params?: {
      body?: InstrumentsManagerApi.InstrumentSearchParamsDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?:
        | 'InstrumentId'
        | 'CountryOfListing'
        | 'CountryOfIncorporation'
        | 'Type'
        | 'Currency'
        | 'Isin'
        | 'BenchmarkFee';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<InstrumentsManagerApi.InstrumentDtoInstrumentSortCriteriaDtoPagingResultDto>
  >;
  instrumentsManagerControllerPostInstrumentsSearch(
    params?: {
      body?: InstrumentsManagerApi.InstrumentSearchParamsDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?:
        | 'InstrumentId'
        | 'CountryOfListing'
        | 'CountryOfIncorporation'
        | 'Type'
        | 'Currency'
        | 'Isin'
        | 'BenchmarkFee';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<InstrumentsManagerApi.InstrumentDtoInstrumentSortCriteriaDtoPagingResultDto>
  >;
  instrumentsManagerControllerPostInstrumentsSearch(
    params?: {
      body?: InstrumentsManagerApi.InstrumentSearchParamsDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?:
        | 'InstrumentId'
        | 'CountryOfListing'
        | 'CountryOfIncorporation'
        | 'Type'
        | 'Currency'
        | 'Isin'
        | 'BenchmarkFee';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<InstrumentsManagerApi.InstrumentDtoInstrumentSortCriteriaDtoPagingResultDto>
  >;
  instrumentsManagerControllerPostInstrumentsSearch(
    params?: {
      body?: InstrumentsManagerApi.InstrumentSearchParamsDto;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?:
        | 'InstrumentId'
        | 'CountryOfListing'
        | 'CountryOfIncorporation'
        | 'Type'
        | 'Currency'
        | 'Isin'
        | 'BenchmarkFee';
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy],
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params?.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ =
      this.httpClient.post<InstrumentsManagerApi.InstrumentDtoInstrumentSortCriteriaDtoPagingResultDto>(
        `${this.basePath}/gateway/admin/instruments-manager/search`,
        params?.body,
        <any>Object.assign(baseOptions, {}),
      );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  instrumentsManagerControllerPostInstrumentBlocksSearch(
    params: {
      body: InstrumentsManagerApi.GetInstrumentBlocksRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CreateDate';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<InstrumentsManagerApi.InstrumentBlocksPagingResultDto>;
  instrumentsManagerControllerPostInstrumentBlocksSearch(
    params: {
      body: InstrumentsManagerApi.GetInstrumentBlocksRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CreateDate';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<InstrumentsManagerApi.InstrumentBlocksPagingResultDto>>;
  instrumentsManagerControllerPostInstrumentBlocksSearch(
    params: {
      body: InstrumentsManagerApi.GetInstrumentBlocksRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CreateDate';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<InstrumentsManagerApi.InstrumentBlocksPagingResultDto>;
  instrumentsManagerControllerPostInstrumentBlocksSearch(
    params: {
      body: InstrumentsManagerApi.GetInstrumentBlocksRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CreateDate';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<InstrumentsManagerApi.InstrumentBlocksPagingResultDto>>;
  instrumentsManagerControllerPostInstrumentBlocksSearch(
    params: {
      body: InstrumentsManagerApi.GetInstrumentBlocksRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CreateDate';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<InstrumentsManagerApi.InstrumentBlocksPagingResultDto>>;
  instrumentsManagerControllerPostInstrumentBlocksSearch(
    params: {
      body: InstrumentsManagerApi.GetInstrumentBlocksRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CreateDate';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<InstrumentsManagerApi.InstrumentBlocksPagingResultDto>>;
  instrumentsManagerControllerPostInstrumentBlocksSearch(
    params: {
      body: InstrumentsManagerApi.GetInstrumentBlocksRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'CreateDate';
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(
      ['', 'pageSize', params.pageSize],
      ['', 'pageNumber', params.pageNumber],
      ['', 'sortDirection', params.sortDirection],
      ['', 'orderBy', params.orderBy],
    );

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<InstrumentsManagerApi.InstrumentBlocksPagingResultDto>(
      `${this.basePath}/gateway/admin/instruments-manager/blocks/search`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  instrumentsManagerControllerPostBlockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<InstrumentsManagerApi.BlockReasonDto>>;
  instrumentsManagerControllerPostBlockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostBlockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<InstrumentsManagerApi.BlockReasonDto>>;
  instrumentsManagerControllerPostBlockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostBlockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostBlockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostBlockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<InstrumentsManagerApi.BlockReasonDto>>(
      `${this.basePath}/gateway/admin/instruments-manager/${this.encodeURI(String(params.id))}/block`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  instrumentsManagerControllerPostUnblockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<InstrumentsManagerApi.BlockReasonDto>>;
  instrumentsManagerControllerPostUnblockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostUnblockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<InstrumentsManagerApi.BlockReasonDto>>;
  instrumentsManagerControllerPostUnblockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostUnblockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostUnblockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerPostUnblockInstrumentById(
    params: { body?: InstrumentsManagerApi.BlockChangeRequest; xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<InstrumentsManagerApi.BlockReasonDto>>(
      `${this.basePath}/gateway/admin/instruments-manager/${this.encodeURI(String(params.id))}/unblock`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  instrumentsManagerControllerPutUpdateInstrumentById(
    params: { body?: InstrumentsManagerApi.UpdateInstrumentRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<InstrumentsManagerApi.InstrumentDto>;
  instrumentsManagerControllerPutUpdateInstrumentById(
    params: { body?: InstrumentsManagerApi.UpdateInstrumentRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<InstrumentsManagerApi.InstrumentDto>>;
  instrumentsManagerControllerPutUpdateInstrumentById(
    params: { body?: InstrumentsManagerApi.UpdateInstrumentRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<InstrumentsManagerApi.InstrumentDto>;
  instrumentsManagerControllerPutUpdateInstrumentById(
    params: { body?: InstrumentsManagerApi.UpdateInstrumentRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<InstrumentsManagerApi.InstrumentDto>>;
  instrumentsManagerControllerPutUpdateInstrumentById(
    params: { body?: InstrumentsManagerApi.UpdateInstrumentRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<InstrumentsManagerApi.InstrumentDto>>;
  instrumentsManagerControllerPutUpdateInstrumentById(
    params: { body?: InstrumentsManagerApi.UpdateInstrumentRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<InstrumentsManagerApi.InstrumentDto>>;
  instrumentsManagerControllerPutUpdateInstrumentById(
    params: { body?: InstrumentsManagerApi.UpdateInstrumentRequest; xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<InstrumentsManagerApi.InstrumentDto>(
      `${this.basePath}/gateway/admin/instruments-manager/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  instrumentsManagerControllerPutUpdateInstrumentIdentifiersById(
    params: {
      body?: InstrumentsManagerApi.UpdateInstrumentIdentifiersRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<InstrumentsManagerApi.InstrumentIdentifiersDto>;
  instrumentsManagerControllerPutUpdateInstrumentIdentifiersById(
    params: {
      body?: InstrumentsManagerApi.UpdateInstrumentIdentifiersRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<InstrumentsManagerApi.InstrumentIdentifiersDto>>;
  instrumentsManagerControllerPutUpdateInstrumentIdentifiersById(
    params: {
      body?: InstrumentsManagerApi.UpdateInstrumentIdentifiersRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<InstrumentsManagerApi.InstrumentIdentifiersDto>;
  instrumentsManagerControllerPutUpdateInstrumentIdentifiersById(
    params: {
      body?: InstrumentsManagerApi.UpdateInstrumentIdentifiersRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<InstrumentsManagerApi.InstrumentIdentifiersDto>>;
  instrumentsManagerControllerPutUpdateInstrumentIdentifiersById(
    params: {
      body?: InstrumentsManagerApi.UpdateInstrumentIdentifiersRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<InstrumentsManagerApi.InstrumentIdentifiersDto>>;
  instrumentsManagerControllerPutUpdateInstrumentIdentifiersById(
    params: {
      body?: InstrumentsManagerApi.UpdateInstrumentIdentifiersRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<InstrumentsManagerApi.InstrumentIdentifiersDto>>;
  instrumentsManagerControllerPutUpdateInstrumentIdentifiersById(
    params: {
      body?: InstrumentsManagerApi.UpdateInstrumentIdentifiersRequest;
      xSgUser?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<InstrumentsManagerApi.InstrumentIdentifiersDto>(
      `${this.basePath}/gateway/admin/instruments-manager/${this.encodeURI(String(params.id))}/identifiers`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  instrumentsManagerControllerGetInstrumentBlockReasonsById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<InstrumentsManagerApi.BlockReasonDto>>;
  instrumentsManagerControllerGetInstrumentBlockReasonsById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerGetInstrumentBlockReasonsById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<InstrumentsManagerApi.BlockReasonDto>>;
  instrumentsManagerControllerGetInstrumentBlockReasonsById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerGetInstrumentBlockReasonsById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerGetInstrumentBlockReasonsById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<InstrumentsManagerApi.BlockReasonDto>>>;
  instrumentsManagerControllerGetInstrumentBlockReasonsById(
    params: { xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<InstrumentsManagerApi.BlockReasonDto>>(
      `${this.basePath}/gateway/admin/instruments-manager/${this.encodeURI(String(params.id))}/block-reasons`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
